import { Typography } from '@components';
import { OrderProductWorkstation } from '@interfaces';
import { Tooltip } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

interface ManagedDevicesChart {
  managed?: number;
  unManaged?: number;
  assets?: any;
}

export const ManagedDevicesChart: FC<ManagedDevicesChart> = ({ assets }) => {
  const [chartData, setChartData] = useState([]);
  const [percentage, setPercentage] = useState<number>(0);
  useEffect(() => {
    const managed: number = assets.filter(
      (item: OrderProductWorkstation) =>
        item.device_id !== null && item.device_id != ''
    ).length;
    const unManaged = assets.length - managed;
    setPercentage(Math.floor((managed / assets.length) * 100));
    setChartData([
      { name: 'CMC Managed', value: managed },
      { name: 'Unmanaged', value: unManaged },
    ]);
  }, [0]);

  const COLORS = ['#D0B1F2', '#876CDD'];

  return (
    <div className="w-full max-w-sm text-center relative">
      <div className="relative w-full h-56">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={70}
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl font-bold text-gray-800">
          <Typography tag="span" type="subtitle">
            {percentage}%
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ManagedDevicesChart;
